export default {
  install(Vue) {
    Vue.prototype.$message = function(variant = 'success', text, autoHideDelay = 5, noAutoHide = false) {
      this.$root.$bvToast.toast('message', {
        title: text,
        variant: variant,
        autoHideDelay: autoHideDelay * 1000,
        noAutoHide: noAutoHide,
        solid: true,
        toastClass: `lh-message-toast ${this.$store.state.is_mobile_or_tablet ? '' : 'lh-toast-desktop'} lh-toast-${variant}`,
        headerClass: `lh-message-toast-header lh-toast-${variant}`,
        bodyClass: 'lh-message-toast-body'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/message.plugin.js